import BrandArtistLookupTab from "../MusicAssetAuditComponents/BrandArtistLookupTab";

const BrandArtistLookupRoute = () => <BrandArtistLookupTab />;

export default BrandArtistLookupRoute;
